"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_router_dom_1 = require("react-router-dom");
const luxon_1 = require("luxon");
const mui_1 = require("tss-react/mui");
const react_redux_1 = require("react-redux");
const material_1 = require("@mui/material");
const core_1 = require("companion-app-components/utils/core");
const compose_1 = __importDefault(require("utils/compose"));
const QPreferences_1 = __importDefault(require("components/QPreferences"));
const selectors_1 = require("data/accountBalances/selectors");
const QPopper_1 = __importDefault(require("components/QPopper"));
const styles_1 = require("../../styles");
const CalTxnsModal_1 = __importDefault(require("../CalTxnsModal"));
const CalDay_1 = __importDefault(require("../CalDay"));
const tabs = ['TRANSACTIONS', 'BALANCES'];
const useStyles = (0, mui_1.makeStyles)()(styles_1.calDaysGridStyles);
const CalDaysGrid = (props) => {
    const { classes } = useStyles();
    const { daysTxsMap, curMonth, onTransactionClick, accountIds, datasetPreferences: { calendarTransaction: calendarTransactionPref }, } = props;
    const navigate = (0, react_router_dom_1.useNavigate)();
    const [anchorEl, setAnchorEl] = (0, react_1.useState)(null);
    const [popperData, setPopperData] = (0, react_1.useState)(null);
    const [showTxnModal, setShowTxnModal] = (0, react_1.useState)(null);
    const [currentTab, setCurrentTab] = (0, react_1.useState)(tabs[0]);
    const todayDate = luxon_1.DateTime.local().toISODate();
    const txnModelDate = showTxnModal === null || showTxnModal === void 0 ? void 0 : showTxnModal.toISODate();
    const setPopper = (0, react_1.useCallback)((popperEl, data) => {
        setAnchorEl(popperEl);
        setPopperData(data);
        if (data) {
            core_1.tracker.track(core_1.tracker.events.calendarOnOpenPopover, {
                type: data.hoveringContent === 'full' ? 'Transactions' : 'Balances',
            });
        }
        else {
            setCurrentTab(tabs[0]);
        }
    }, [setAnchorEl, setPopperData, setCurrentTab]);
    const onGoToBills = (0, react_1.useCallback)((id) => {
        navigate(`/bills-and-income?selectNode=${id}`);
        core_1.tracker.track(core_1.tracker.events.calendarOnGoToBills, { schTxn: id });
    }, [navigate]);
    const onMouseLeave = (0, react_1.useCallback)(() => {
        setPopper(null, null);
    }, [setPopper]);
    const onTxnsModalOpen = (0, react_1.useCallback)((date) => {
        setShowTxnModal(date);
        core_1.tracker.track(core_1.tracker.events.calendarTxnModalOpen, { date: date.toISODate() });
    }, [setShowTxnModal]);
    const onTxnsModalClose = (0, react_1.useCallback)(() => {
        setShowTxnModal(null);
    }, [setShowTxnModal]);
    const cachedCalendarTransactionPref = (0, react_1.useMemo)(() => calendarTransactionPref, [calendarTransactionPref]);
    const balancesData = (0, react_redux_1.useSelector)((state) => {
        const canGetData = cachedCalendarTransactionPref.showDailyBalances && daysTxsMap;
        return canGetData ? (0, selectors_1.getBalancesForAccountsAtDates)(state, {
            accountIds, dates: [...daysTxsMap.keys()],
        }) : null;
    });
    const balances = (0, react_1.useMemo)(() => balancesData, [balancesData]);
    const renderedDays = (0, react_1.useMemo)(() => (daysTxsMap && daysTxsMap.map((txnList, date) => {
        var _a;
        const dateLux = luxon_1.DateTime.fromISO(date);
        const currentMonth = dateLux.month === ((_a = curMonth === null || curMonth === void 0 ? void 0 : curMonth.date) === null || _a === void 0 ? void 0 : _a.month);
        const currentDay = todayDate === date;
        const balanceForDay = balances && (balances.has(date) ? balances.get(date) : undefined);
        return (<CalDay_1.default key={dateLux.toISODate()} setPopper={setPopper} day={dateLux.day} date={dateLux} currentMonth={currentMonth} currentDay={currentDay} txnList={txnList} balances={balanceForDay} onTxnsModalOpen={onTxnsModalOpen}/>);
    }).toList()), [daysTxsMap, balances, curMonth, onTxnsModalOpen, todayDate, setPopper]);
    const handleTabChange = (_, tab) => {
        setCurrentTab(tab);
    };
    const renderPopperContent = (0, react_1.useCallback)(() => {
        var _a, _b, _c;
        return (<div className={classes.popperRoot}>
      {(_a = popperData === null || popperData === void 0 ? void 0 : popperData.content) === null || _a === void 0 ? void 0 : _a.header}
      <material_1.Tabs value={currentTab} onChange={handleTabChange} classes={{
                indicator: classes.customIndicator,
            }} className={classes.tabs} variant="fullWidth">
        {tabs.map((tab) => (<material_1.Tab label={tab} value={tab} key={tab}/>))}
      </material_1.Tabs>
      {currentTab === tabs[0] && ((_b = popperData === null || popperData === void 0 ? void 0 : popperData.content) === null || _b === void 0 ? void 0 : _b.transactions)}
      {currentTab === tabs[1] && ((_c = popperData === null || popperData === void 0 ? void 0 : popperData.content) === null || _c === void 0 ? void 0 : _c.balance)}
    </div>);
    }, [popperData, classes, currentTab]);
    const openPopper = (0, react_1.useMemo)(() => Boolean(anchorEl) && Boolean(popperData), [anchorEl, popperData]);
    return (<>
      <div className={classes.days} onMouseLeave={onMouseLeave}>
        {daysTxsMap && renderedDays}
        <QPopper_1.default id="transaction-calendar-popper" open={openPopper} anchorEl={anchorEl} placement="top" disablePortal transition transitionEffect="fade" modifiers={[
            {
                name: 'offset',
                enabled: true,
                options: {
                    offset: [0, 10],
                },
            },
        ]}>
          {renderPopperContent()}
        </QPopper_1.default>
      </div>
      <p className={classes.footnote}>The Calendar View only uses information from your banking accounts. It does not include investment account information.</p>
      {showTxnModal && (<CalTxnsModal_1.default onClose={onTxnsModalClose} date={showTxnModal.toLocaleString(luxon_1.DateTime.DATE_HUGE)} txns={txnModelDate ? daysTxsMap.get(txnModelDate) : undefined} onGoToRegister={onTransactionClick} onGoToBills={onGoToBills}/>)}
    </>);
};
exports.default = (0, compose_1.default)((0, QPreferences_1.default)())(react_1.default.memo(CalDaysGrid));
